import {
  Avatar,
  Flex,
  Image,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { photoBaseURL } from "../../../../service/api";
import { trunc } from "../../../../utils";

function FollowersStoryCard({ story, mystory }) {
  const textColor1 = useColorModeValue("#444D6E", "#fff");

  const getFirstStory = story?.stories?.[0];
  const user = story?.user;
  // console.log('storyUser:', user);
  return (
    <Stack>
      <Stack position={"relative"}>
        <Flex
          w="60px"
          h="60px"
          maxW="60px"
          maxH={"60px"}
          objectFit={"cover"}
          borderRadius={"20px"}
          bg={getFirstStory?.content?.background}
          justify="center"
          align="center"
        >
          {getFirstStory?.type === "video" ? (
            <video
              loop
              width="100%"
              controls
              style={{ borderRadius: "20px", height: "100%" }}
            >
              <source
                src={`${photoBaseURL}${story?.content}`}
                type={getFirstStory?.type}
              />
              Your browser does not support HTML5 video.
            </video>
          ) : getFirstStory?.type === "image" ? (
            <Image
              w="60px"
              h="60px"
              objectFit={"cover"}
              borderRadius={"20px"}
              src={`${getFirstStory?.content?.file}`}
            />
          ) : (
            <Text
              fontSize={"8px"}
              textAlign={"center"}
              lineHeight="1"
              color={getFirstStory?.content?.color}
              fontWeight="bold"
            >
              {trunc(getFirstStory?.content?.text, 20)}
            </Text>
          )}
        </Flex>

        <Stack position={"absolute"} bottom={"-8px"} left="20px">
          <Avatar
            size={"xs"}
            name={story?.name}
            objectFit={"cover"}
            src={story?.picture}
            alt="story pic"
          />
        </Stack>
      </Stack>
      <Text color={textColor1} textAlign="center" fontSize={".7em"}>
        {story?.username}
      </Text>
    </Stack>
  );
}

export default FollowersStoryCard;
